import script from "./MyContractsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyContractsView.vue?vue&type=script&setup=true&lang=ts"

import "./MyContractsView.vue?vue&type=style&index=0&id=05e9a93c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e9a93c"]])

export default __exports__